import { render, staticRenderFns } from "./AreaEventHistory.vue?vue&type=template&id=2767e428&scoped=true"
import script from "./AreaEventHistory.vue?vue&type=script&lang=ts"
export * from "./AreaEventHistory.vue?vue&type=script&lang=ts"
import style0 from "./AreaEventHistory.vue?vue&type=style&index=0&id=2767e428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767e428",
  null
  
)

export default component.exports